<template>
    <div class="pt-3">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto form-inline">
                <multiselect
                    v-if="canView()"
                    v-model="search.sale"
                    class="form-control border-0"
                    :options="seller"
                    :customLabel="saleLabel"
                    placeholder="กรุณาเลือกเซลล์"
                    :show-labels="false"
                    @input="filter()"
                    track-by="sale_id">
                </multiselect>
                &nbsp
                <date-picker v-model="search.date"
                             placeholder="วันที่"
                             :format="changeFormat"
                             @change="filter()"
                             :lang="lang">
                </date-picker>
                &nbsp
                <multiselect
                    v-if="search.date"
                    v-model="search.time"
                    class="form-control border-0"
                    :options="timeList"
                    placeholder="เลือกช่วงเวลา"
                    :show-labels="false"
                    @input="filter()">
                </multiselect>
                &nbsp
                <multiselect
                    v-model="search.product_type"
                    class="form-control border-0"
                    :options="optionProductType"
                    track-by="id"
                    :show-labels="false"
                    :custom-label="LabelName"
                    @input="filter()"
                    placeholder="เลือกประเภทสินค้า">
                </multiselect>
                &nbsp
                <button @click="showQuotaModal()"
                        class="btn btn-warning my-2 my-sm-0"
                        type="button">
                    <icon name="plus"></icon>
                    จองโควต้า
                </button>
            </div>
        </nav>
        <!--        <nav class="navbar navbar-expand-lg navbar-light">-->
        <!--            <div class="ml-auto">-->
        <!--                <form class="form-inline my-2 my-lg-0">-->
        <!--                    -->
        <!--                </form>-->
        <!--            </div>-->
        <!--        </nav>-->
        <div class="col-12 table-responsive">
            <table class="table table-bordered" style="text-align: center">
                <thead>
                <tr>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">ยอดคงเหลือยกมา</th>
                    <th scope="col">วันที่จอง</th>
                    <th scope="col">จำนวนที่จอง(คงเหลือ)</th>
                    <th scope="col">วันที่จอง</th>
                    <th scope="col">จำนวนที่จอง(คงเหลือ)</th>
                    <th scope="col">วันที่จอง</th>
                    <th scope="col">จำนวนที่จอง(คงเหลือ)</th>
                    <th scope="col">นำเข้า</th>
                    <th scope="col">ขายออก</th>
                    <th scope="col">คงเหลือ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(x,ix) in list">
                    <td>{{ calculateRemain(x).sku }}</td>
                    <td>
                        <span v-if="canView()" class="can-edit" @click="showQuotaFixModal(x)">
                            {{ calculateRemain(x).remain }}
                        </span>
                        <span v-else>
                            {{ calculateRemain(x).remain }}
                        </span>
                    </td>
                    <template v-for="(y,iy) in x">
                        <td v-if="backThreeDay.includes(y.date)">
<!--                            <input readonly placeholder="วันที่จอง" v-model="y.formatDate"-->
<!--                                   class="form-control"/>-->
                            <div style="width: 100%;border-radius: 5px;height:35px;background-color:#e9f0eb;border: 1px black solid;text-align: left" class="text-center">
                                <span class="text-center">{{y.formatDate}}</span>
                            </div>
                        </td>
                        <td v-else>
<!--                            <input readonly placeholder="วันที่จอง" v-model="y.date"-->
<!--                                   class="form-control"/>-->
                            <div style="width: 100%;border-radius: 5px;height:35px;background-color:#e9f0eb;border: 1px black solid;text-align: left" class="text-center">
                                <span class="text-center">{{y.date}}</span>
                            </div>
                        </td>
                        <td v-if="backThreeDay.includes(y.date)">
<!--                            <input readonly type="number" placeholder="จำนวนที่จอง"-->
<!--                                   v-model="y.quota_left"-->
<!--                                   class="form-control"/>-->
                            <div style="width: 100%;border-radius: 5px;height:35px;background-color:#e9f0eb;border: 1px black solid;text-align: left" class="text-center">
                                <span class="text-center">{{y.amount+'('+y.quota_left+')'}}</span>
                            </div>
                        </td>
                        <td v-else>
                            <input readonly placeholder="จำนวนที่จอง"
                                   class="form-control"/>
                        </td>
                    </template>
                    <td>
<!--                        {{ Math.floor(calculateRemain(x).import / (seller.length + 1)) }}-->
                        {{ calculateRemain(x).import }}
                    </td>
                    <td>
                        {{ calculateRemain(x).used }}
                    </td>
                    <td :class="{'text-red':calculateRemain(x).total<0}">
                        {{ calculateRemain(x).total }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status" @submit="hideLoadingModal"></loading>
        </b-modal>
        <b-modal size="l" hide-header hide-footer ref="quota_modal" no-close-on-backdrop>
            <h4 class="text-center">จองโควต้า</h4>
            <div class="row form-group">
                <div class="col-4 text-right">
                    <label>วันที่จอง</label>
                </div>
                <div class="col-6">
                    <date-picker v-model="quota.date"
                                 placeholder="วันที่จอง"
                                 :disabled="!canView()"
                                 :format="changeFormat"
                                 :lang="lang">
                    </date-picker>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-4 text-right">
                    <label>รหัสสินค้า</label>
                </div>
                <div class="col-6">
                    <multiselect
                        v-model="quota.product"
                        :options="optionProducts"
                        track-by="id"
                        :show-labels="false"
                        :custom-label="LabelNameSku"
                        placeholder="รหัสสินค้า">
                    </multiselect>
                </div>
            </div>
            <div class="row form-group" v-if="canView()">
                <div class="col-4 text-right">
                    <label>เลือกเซล</label>
                </div>
                <div class="col-6">
                    <multiselect
                        v-model="quota.sale"
                        multiple
                        :closeOnSelect="false"
                        :options="seller"
                        :customLabel="saleLabel"
                        placeholder="กรุณาเลือกเซลล์"
                        :show-labels="false"
                        track-by="sale_id">
                    </multiselect>
                </div>
            </div>
            <!--            <div class="row form-group">-->
            <!--                <div class="col-4 text-right">-->
            <!--                    <label>เลือกเซล</label>-->
            <!--                </div>-->
            <!--                <div class="col-6">-->
            <!--                    <multiselect-->
            <!--                        v-if="canView()"-->
            <!--                        v-model="quota.sale"-->
            <!--                        multiple-->
            <!--                        :closeOnSelect="false"-->
            <!--                        :options="seller"-->
            <!--                        :customLabel="saleLabel"-->
            <!--                        placeholder="กรุณาเลือกเซลล์"-->
            <!--                        :show-labels="false"-->
            <!--                        track-by="sale_id">-->
            <!--                    </multiselect>-->
            <!--                </div>-->
            <!--            </div>-->
            <div class="row form-group">
                <div class="col-4 text-right">
                    <label>จำนวนที่จอง</label>
                </div>
                <div class="col-6">
                    <input type="number" placeholder="0.00" v-model="quota.amount" class="form-control"/>
                </div>
            </div>
            <div class="col text-center">
                <button class="btn btn-success" @click="submit">บันทึก</button>&nbsp;
                <button class="btn btn-outline-secondary" @click="hideQuotaModal">ยกเลิก</button>&nbsp;
            </div>
        </b-modal>
        <b-modal size="l" hide-header hide-footer ref="quota_fix_modal" no-close-on-backdrop>
            <h4 class="text-center">เปลี่ยนยอดคงเหลือยกมา</h4>
            <div class="row form-group">
                <div class="col-6">{{ quota_fix.product }}</div>
                <div class="col-6">
                    <input type="number" placeholder="0.00" v-model="quota_fix.amount" class="form-control"/>
                </div>
            </div>
            <div class="col text-center">
                <button class="btn btn-success" @click="editFixValue">บันทึก</button>&nbsp;
                <button class="btn btn-outline-secondary" @click="hideQuotaFixModal">ยกเลิก</button>&nbsp;
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";

import {canSaleView, canViewSuperAdmin} from "../../util/Permissions";

import Loading from "../Utility/Loading";
import moment from "moment/moment";
import DatePicker from "vue2-datepicker";
import BillingModal from "@/components/Accounting/Billing/BillingModal.vue";

export default {
    name: "quota-sale-create",
    components: {
        BillingModal,
        Loading,
        Multiselect,
        DatePicker
    },
    data() {
        return {
            msg: 'กำลังโหลดข้อมูล',
            status: 1,
            list: [],
            listIE: [],
            ytd_quota: [],
            out_date: [],
            search: {
                date: '',
                product_type: '',
                sale: '',
                time: ''
            },
            quota: {
                date: new Date,
                amount: 0,
                product: '',
                sale: [],
            },
            quota_fix: {
                amount: 0,
                product: '',
                sale_id: '',
                date: '',
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            backThreeDay: [
                moment().subtract(3, "days").format("YYYY-MM-DD"),
                moment().subtract(2, "days").format("YYYY-MM-DD"),
                moment().subtract(1, "days").format("YYYY-MM-DD")
            ],
            quotaFix: [],
            quotaLeft: [],
            productExportPerDay: [],
            timeList: ['กะเช้า','กะเย็น']
        };
    },
    created() {
        if (canSaleView() && !canViewSuperAdmin()) {
            this.index({page: 1});
            this.search.sale = this.seller.filter(x => (x.id == this.user.id))[0]
        }
        this.$store.dispatch("ProductType/get");
        this.$store.dispatch("Seller/get");
    },
    computed: {
        canViewSuperAdmin,
        canSaleView,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            optionProducts: (state) => {
                return state.Products.product_all
            },
            seller: state => {
                return state.Seller.data;
            },
            optionProductType: state => {
                return state.ProductType.data;
            },
        })
    },
    methods: {
        editFixValue() {
            this.quota_fix.sale_id = this.search.sale.id;
            this.quota_fix.date = this.search.date ? moment(this.search.date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
            this.$store.dispatch('Products/editQuotaFix', this.quota_fix).then(res => {
                this.filter();
            })
        },
        showQuotaFixModal(x) {
            let item = this.calculateRemain(x)
            this.$refs.quota_fix_modal.show();
            this.quota_fix.amount = item.remain;
            this.quota_fix.product = item.sku;
        },
        hideQuotaFixModal() {
            this.$refs.quota_fix_modal.hide();
        },
        canView() {
            let qc = ['10223', '10228', '10701', '20648', '20701', '20726', '20729', '20655', '20708', '20683']
            let admin = ['20533']
            return (qc.includes(this.user.username) || admin.includes(this.user.username) || canViewSuperAdmin())
        },
        changeDate(date) {
            if (date)
                this.backThreeDay = [
                    moment(date).subtract(3, "days").format("YYYY-MM-DD"),
                    moment(date).subtract(2, "days").format("YYYY-MM-DD"),
                    moment(date).subtract(1, "days").format("YYYY-MM-DD")
                ]
            else
                this.backThreeDay = [
                    moment().subtract(3, "days").format("YYYY-MM-DD"),
                    moment().subtract(2, "days").format("YYYY-MM-DD"),
                    moment().subtract(1, "days").format("YYYY-MM-DD")
                ]
        },
        filter() {
            if ((this.search.sale && this.canView()) || (this.search.date && !this.canView())) {
                this.showLoadingModal();
                this.msg = 'กำลังโหลดข้อมูล'
                this.status = 1;
                this.changeDate(this.search.date ? this.search.date : null)
                this.index({
                    page: 1,
                    date: this.search.date ? this.search.date : '',
                    product_type: this.search.product_type,
                    sale_id: this.search.sale ? this.search.sale.id : ''
                })
            }
        },
        calculateRemain(item) {
            let product = {};
            let productQuantity = 0;
            let quotaQuantityLeft = 0;
            let used = 0;
            let importProduct = 0;
            let exportProduct = 0;
            let amount = 0;
            let outDate = 0;
            let sumImport = 0;
            let remain = 0;
            let total = 0;
            let amountQuota = 0;
            const saleAmount = 12;
            const format = 'hh:mm:ss';
            const currentTime = moment().format('H:m:s');
            // const currentTime = '16:00:00';
            const time = moment(currentTime,format);
            const beforeTime = moment('07:00:00', format);
            const afterTime = moment('15:59:59', format);
            const containsKey = (obj, key ) => Object.keys(obj).includes(key);
            item.forEach(x => {
                if (x.product)
                    product = x
                if (x.used)
                    used += x.used
                if (x.amount) {
                    amount += x.amount
                    x.quota_left = x.amount
                    amountQuota += x.amount
                }
            })
            if (product) {
                productQuantity = product.product.quantity;
                if (containsKey(this.quotaLeft, (product.product.id).toString()))
                    quotaQuantityLeft = this.quotaLeft[product.product.id]
                else
                    quotaQuantityLeft = 0
                if (containsKey(this.productExportPerDay, product.product.id.toString())) {
                    let totalSell = this.productExportPerDay[product.product.id]
                    item.forEach(x => {
                        if(totalSell > 0){
                            if (x.amount && x.amount - totalSell >= 0){
                                x.quota_left = x.amount - totalSell
                                totalSell -= x.amount
                            }else{
                                x.quota_left = 0;
                                totalSell -= x.amount
                            }
                        }
                    })
                }
            }
            let timeStartAccept = null;
            if (this.search.date)
                timeStartAccept = new Date(this.search.date)
            else
                timeStartAccept = new Date();
            timeStartAccept.setHours(7);
            timeStartAccept.setMinutes(0);
            timeStartAccept.setSeconds(0);
            let timeEndAccept = null;
            if (this.search.date)
                timeEndAccept = new Date(this.search.date)
            else
                timeEndAccept = new Date();
            timeEndAccept.setHours(15);
            timeEndAccept.setMinutes(59);
            timeEndAccept.setSeconds(59);
            if (product.product && product.product.import && product.product.import.length > 0) {
                let exceptImport = product.product.import.filter(x => {
                    return timeStartAccept < new Date(x.created_at) && timeEndAccept > new Date(x.created_at)
                })
                importProduct = exceptImport.reduce((a, o) => {
                    return a + o.quantity;
                }, 0);
            }
            if (product.product && product.product.export && product.product.export.length > 0) {
                let exceptExport = product.product.export.filter(x => {
                    return timeStartAccept < new Date(x.created_at) && timeEndAccept > new Date(x.created_at)
                })
                exportProduct = exceptExport.reduce((a, o) => {
                    return a + o.quantity;
                }, 0);
            }
            if ((!this.search.time && time.isBetween(beforeTime, afterTime)) || (this.search.time && this.search.time == 'กะเช้า')) {
                importProduct = 0;
                used = 0;
                remain = Math.floor((productQuantity-quotaQuantityLeft)/saleAmount);
                if (remain < 0)
                    remain = 0;
                if (this.search.sale && this.search.sale.id == 28)
                    remain *= 2
                total = remain + importProduct;
            }else if(!this.search.time || (this.search.time && this.search.time == 'กะเย็น')){
                if (containsKey(this.productExportPerDay, product.product.id.toString()))
                    used = this.productExportPerDay[product.product.id]
                else
                    used = 0;
                remain = Math.floor((productQuantity-quotaQuantityLeft)/saleAmount);
                if (remain < 0)
                    remain = 0;
                importProduct = Math.floor(importProduct / saleAmount);
                if (this.search.sale && this.search.sale.id == 28) {
                    remain *= 2
                    importProduct *= 2
                }
                total = remain + amountQuota + importProduct - used;
            }
            return {
                sku: product.product ? product.product.sku : '',
                remain: remain,
                used: used,
                amount: amount,
                import: importProduct,
                outDate: outDate,
                extraImport: sumImport,
                total: total
            };
        },
        LabelNameSku(option) {
            return `${option.sku} - ${option.name}`
        },
        LabelName(option) {
            return `${option.type_code} - ${option.name}`
        },
        saleLabel(option) {
            return `${option.sale_id} - ${option.name}`
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showQuotaModal() {
            this.$refs.quota_modal.show();
        },
        hideQuotaModal() {
            this.$refs.quota_modal.hide();
        },
        index(data) {
            let payload = {
                page: data.page,
                // view_all: canSaleView() && canViewSuperAdmin(),
                sale_id: this.canView() && data.sale_id ? data.sale_id : this.user.id,
                date: data.date ? moment(data.date).format('YYYY-MM-DD') : '',
                product_type: data.product_type ? data.product_type.id : ''
            }
            this.$store.dispatch('Products/listQuota', payload).then(res => {
                this.quotaFix = res.quota_fix;
                this.quotaLeft = res.quota_left;
                this.productExportPerDay = res.product_export_per_day;
                let data = res.data
                Object.keys(data).forEach(x => {
                    let temp = data[x];
                    for (let i = 2; i >= 0; i--) {
                        if (temp[i]) {
                            temp[i].formatDate = moment(temp[i].date).format("DD-MM-YYYY");
                            data[x][this.backThreeDay.indexOf(temp[i].date)] = temp[i]
                        }
                        if (!temp[i] || (temp[i].date != this.backThreeDay[i] && temp[i].id != null))
                            data[x][i] = {date: moment(this.backThreeDay[i]).format("DD-MM-YYYY")}
                    }
                })
                this.ytd_quota = res.ytd_quota
                this.out_date = res.out_date
                this.list = data
                this.listIE = res.data_ie
                this.hideLoadingModal()
            })
        },
        submit() {
            this.msg = 'กำลังบันทึกข้อมูล'
            this.status = 1
            this.showLoadingModal()
            if (this.quota.product && this.quota.product && this.quota.amount != 0) {
                this.quota.date = this.quota.date ? moment(this.quota.date).format('YYYY-MM-DD') : null;
                this.quota.product = this.quota.product ? this.quota.product.id : null;
                let id_sale = '';
                this.quota.sale.forEach((a, i) => {
                    this.quota.sale.length == i + 1 ? id_sale = id_sale + a.id : id_sale = id_sale + a.id + ',';
                })
                let data = {
                    date: this.quota.date,
                    product_id: this.quota.product,
                    sale_id: this.user.id,
                    amount: this.quota.amount,
                    sale: id_sale,
                    is_admin: this.canView()
                }
                this.quota = {
                    date: new Date,
                    amount: 0,
                    product: '',
                    sale_id: []
                }
                this.$store.dispatch('Products/createQuota', data).then(res => {
                    this.msg = res.message;
                    this.status = 2;
                    this.hideQuotaModal();
                    this.index({page: 1});
                })
            } else {
                this.msg = 'กรุณาใส่ข้อมูลให้ครบถ้วน';
                this.status = 3;
                this.showLoadingModal();
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.text-red {
    color: red;
}

.can-edit {
    text-decoration: underline;
    cursor: pointer;
}
</style>
